<template>
  <div>
    <div class="drawer-content">
      <a-drawer
        :width="750"
        @close="rightDrawerClose"
        :visible="drawerVisibleFlag"
      >
        <div slot="title">
          {{ drawerTitle }}&emsp;
          <a-tag color="cyan">
            {{ publishMealTypeName }}
          </a-tag>
        </div>
        <a-form v-show="!globalEditAble">
          <a-row :gutter="48">
            <a-col :md="24" style="display:flex">
              <a-form-item>
                <a-date-picker v-model="searchDate" />
              </a-form-item>
              <a-button
                class="sm"
                type="primary"
                style="margin-left:20px;margin-top: 4px;"
                @click="getPublishList"
              >
                <a-icon type="search" />加载
              </a-button>
              <a-button
                class="sm"
                type="primary"
                style="margin-left:20px;margin-top: 4px;"
                @click="getAllMenuList"
              >
                加载全部菜品
              </a-button>
            </a-col>
          </a-row>
        </a-form>
        <!-- content -->
        <a-table
          :columns="columns"
          :dataSource="childPublishListData"
          :pagination="false"
          :loading="publishTableLoading"
        >
          <template
            v-for="(col, i) in ['name', 'img', 'price', 'amount', 'desc']"
            :slot="col"
            slot-scope="text, record"
          >
            <!-- table -->
            <template v-if="col === 'name'">
              <menu-select
                :publishMealType="publishMealType"
                :key="col"
                v-if="record.editable && (!globalEditAble || record.isNew)"
                :defaultValue="menuSelectDDefaaultVal"
                @select="handleMenuSelect(record.key, arguments)"
              ></menu-select>
              <template v-else>{{ text }}</template>
            </template>
            <template v-else-if="col === 'img'">
              <a-avatar
                :key="col"
                slot="avatar"
                size="large"
                shape="square"
                :src="text ? text : 'images/noImg.jpg'"
              />
            </template>
            <template v-else-if="col === 'price'">
              <a-input
                :key="col"
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                placeholder="单价"
                @change="e => handleChange(e.target.value, record.key, col)"
              />
              <template v-else>{{ text }}</template>
            </template>
            <template v-else-if="col === 'amount'">
              <a-input
                :key="col"
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                placeholder="份数"
                @change="e => handleChange(e.target.value, record.key, col)"
              />
              <template v-else>{{ text }}</template>
            </template>
          </template>
          <template slot="operation" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew">
                <a @click="saveRow(record)">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="是否要删除此行？"
                  @confirm="removeRow(record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a @click="saveRow(record)">保存</a>
                <a-divider type="vertical" />
                <a @click="cancel(record.key)">取消</a>
              </span>
            </template>
            <span v-else>
              <a @click="editRow(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="是否要删除此行？"
                @confirm="removeRow(record)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newPublishMenu"
          >新增菜品</a-button
        >
        <!-- footer -->
        <div
          v-show="!globalEditAble"
          :style="{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="rightDrawerClose"
            >取消</a-button
          >
          <a-button
            type="primary"
            @click="publishMenuSubmit"
            :loading="publishMenuSubmitLoading"
            >发布</a-button
          >
        </div>
      </a-drawer>
    </div>
    <select-all-menu
      :publishMenuList="childPublishListData"
      :modalLoading="allMenuLoading"
      :tableData="selectAllMenuList"
      :visible="allMenuShowFlag"
      @showModal="allMenuShow"
      @hideModal="allMenuHide"
      @handleOk="allMenuHandleOk"
      :tableLoading="allMenuTableLoading"
    ></select-all-menu>
  </div>
</template>

<script>
import menuSelect from "./select-menu";

import selectAllMenu from './select-all-menu';

import { getMenuType } from '@/apis/menu'
import {
  onekeyPublishMenu,
  delPublishMenu,
  addPublishMenu,
  editPublishMenu,
  getPublishMenu,
  publishMenuTest,
  getMenuList
} from "@/apis/publishMenu";
import { dateConvert } from "@/components/tools/date-convert";
import { arrIsRepeat } from "@/utils/base";
import moment from "moment";

const columns = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    width: "60px"
  },
  {
    title: "菜品名称",
    dataIndex: "name",
    key: "name",
    width: "150px",
    scopedSlots: { customRender: "name" }
  },
  {
    title: "图片",
    dataIndex: "img",
    key: "img",
    width: "100px",
    scopedSlots: { customRender: "img" }
  },
  {
    title: "单价（元）",
    dataIndex: "price",
    key: "price",
    width: "100px",
    scopedSlots: { customRender: "price" }
  },
  {
    title: "份数",
    dataIndex: "amount",
    key: "amount",
    width: "100px",
    scopedSlots: { customRender: "amount" }
  },
  {
    title: "操作",
    key: "action",
    width: "110px",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      columns,
      drawerTitle: "发布菜品",
      searchDate: null,
      childPublishListData: [],
      publishTableLoading: false,
      menuSelectDDefaaultVal: "",
      publishMenuSubmitLoading: false,
      allMenuShowFlag: false,
      selectAllMenuList: [],
      allMenuLoading: false,
      allMenuTableLoading: false,
      menuTypeList: []
    };
  },
  props: {
    drawerVisibleFlag: {
      type: Boolean,
      default: false
    },
    publishDate: {
      type: String,
      default: dateConvert.convert(new Date(), "yyyy-MM-dd")
    },
    publishMealType: {
      type: Number,
      default: 1
    },
    globalEditAble: {
      type: Boolean,
      default: false
    },
    publishListData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    _getMenuType() {
      getMenuType().then(res => {
        if (res.data.state === 1) {
          this.menuTypeList = res.data.attribute
        }
      })
    },
    getAllMenuList() {
      this.allMenuShow()
      this.allMenuTableLoading = true
      getMenuList({
        name: '',
        eatType: this.publishMealType
      }).then(res => {
        this.allMenuTableLoading = false
        if (res.data.state === 1) {
          const result = res.data.attribute
          const tempData = []

          result.packages.forEach(item => {
            let itemImgUrl = ''
            for (let i = 0; i < item.menus.length; i++) {
              if (item.menus[i].imgUrl) {
                itemImgUrl = item.menus[i].imgUrl
                break
              }
            }
            tempData.push({
              key: item.id,
              id: item.id,
              code: item.codeNumber,
              name: item.name,
              menus: item.menus,
              menuTypeName: '营养套餐',
              isPackage: true,
              imgUrl: itemImgUrl,
              defaultUnitPrice: item.defaultPrice ? item.defaultPrice : '0'
            })
          })

          result.menus.forEach(item => {
            const tempArr = this.menuTypeList.filter(zitem => zitem.id === item.menuType)
            const menuTypeName = tempArr.length > 0 ? tempArr[0].text : ''

            tempData.push({
              key: item.id,
              id: item.id,
              name: item.name,
              isPackage: false,
              imgUrl: item.imgUrl,
              menuTypeName,
              defaultUnitPrice: item.defaultUnitPrice
            })
          })
          this.selectAllMenuList = tempData
        }
      })
    },
    allMenuShow() {
      this.allMenuShowFlag = true
    },
    allMenuHide() {
      this.allMenuShowFlag = false
    },
    allMenuHandleOk(selectedRows, amount) {
      this.allMenuLoading = true
      selectedRows.forEach((item, index) => {
        const length = this.childPublishListData.length
        this.childPublishListData.push({
          key:
            length === 0
              ? "1"
              : (
                parseInt(this.childPublishListData[length - 1].key) + 1
              ).toString(),
          index:
            length === 0
              ? 1
              : parseInt(this.childPublishListData[length - 1].key) + 1,
          name: item.name,
          menuId: item.id,
          img: item.imgUrl,
          price: item.defaultUnitPrice,
          amount: amount,
          isPackage: item.isPackage,
          packageCode: item.code,
          menuList: item.isPackage ? item.menus : [],
          isNew: false,
          editable: false
        });
      })
      this.allMenuLoading = false
      this.allMenuShowFlag = false
    },
    // moment插件
    moment,
    // 获取指定日期的发布菜品列表
    getPublishList() {
      if (this.searchDate) {
        const date = this.searchDate.format("YYYY-MM-DD");
        this.publishTableLoading = true;
        getPublishMenu({
          date: date,
          isShow: false
        }).then(res => {
          this.publishTableLoading = false;
          if (res.data.state === 1) {
            let temp = [];
            const result = res.data.attribute;

            let getDataList = (result, i) => {
              let current = 0;
              let retData = new Array(3);
              for (let key in result) {
                let tempData = [];
                result[key].packages.forEach(item => {
                  let itemImgUrl = "";
                  for (let i = 0; i < item.menus.length; i++) {
                    if (item.menus[i].imgUrl) {
                      itemImgUrl = item.menus[i].imgUrl;
                      return;
                    }
                  }
                  tempData.push({
                    amount: item.amount,
                    describe: item.remark ? item.remark : "-",
                    id: item.id,
                    imgUrl: itemImgUrl,
                    menuId: item.menuId,
                    name: item.name,
                    code: item.codeNumber,
                    unitPrice: item.packagePrice,
                    isPackage: true
                  });
                });
                result[key].menus.forEach(item => {
                  tempData.push(item);
                });
                retData[current] = tempData;
                current++;
              }
              return retData[i - 1];
            };
            switch (this.publishMealType) {
              case 1:
                temp = getDataList(result, 1);
                break;
              case 2:
                temp = getDataList(result, 2);
                break;
              case 3:
                temp = getDataList(result, 3);
                break;
              default:
                break;
            }
            this.childPublishListData = [];
            // 接收请求的数据
            temp.forEach((item, index) => {
              this.childPublishListData.push({
                key: (index + 1).toString(),
                index: index + 1,
                menuId: item.menuId,
                name: item.name,
                img: item.imgUrl,
                price: item.unitPrice,
                desc: item.describe,
                amount: item.amount,
                publicMenuType: item.publicMenuType,
                isPackage: item.isPackage !== undefined,
                packageCode: item.code,
                isNew: false,
                editable: false
              });
            });
          } else {
            this.$message.warning(res.data.message);
          }
        }, res => {
          this.publishTableLoading = false;
        });
      }
    },
    rightDrawerClose() {
      this.$emit("close");
    },
    // 新增一条菜品Item
    newPublishMenu() {
      const length = this.childPublishListData.length;
      this.childPublishListData.push({
        key:
          length === 0
            ? "1"
            : (
              parseInt(this.childPublishListData[length - 1].key) + 1
            ).toString(),
        index:
          length === 0
            ? 1
            : parseInt(this.childPublishListData[length - 1].key) + 1,
        menuId: 0,
        name: "",
        img: "",
        price: "",
        desc: "-",
        amount: 10,
        isNew: true,
        editable: true
      });
      this.menuSelectDDefaaultVal = "";
    },
    // 删除item
    removeRow(record) {
      const key = record.key;
      if (this.globalEditAble && !record.isNew) {
        // 编辑发布菜品时
        const currentData = this.childPublishListData.filter(
          item => item.key === key
        )[0];
        this.publishTableLoading = true;
        delPublishMenu({
          id: currentData.id,
          addOrEditMenuType: currentData.isPackage ? 2 : 1
        }).then(res => {
          this.publishTableLoading = false;
          if (res.data.state === 1) {
            this.$message.success("删除成功");
            let newData = this.childPublishListData.filter(
              item => item.key !== key
            );
            this.handleArrayIndexNumber(newData);
            this.childPublishListData = newData;
          }
        }, res => {
          this.publishTableLoading = false;
        });
      } else {
        let newData = this.childPublishListData.filter(
          item => item.key !== key
        );
        this.handleArrayIndexNumber(newData);
        this.childPublishListData = newData;
      }
    },
    handleArrayIndexNumber(arr) {
      arr.forEach((item, index) => {
        item.index = index + 1;
      });
    },
    // 保存item
    saveRow(record) {
      const { key, name, price, amount } = record;

      if (!name || !price) {
        this.$message.warning("请填写完整信息！");
        return;
      }
      if (!/(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/.test(price)) {
        this.$message.warning("菜品单价格式不正确！");
        return;
      }
      if (!/^\+?[1-9][0-9]*$/.test(amount)) {
        this.$message.warning("菜品份数需为正整数！");
        return;
      }

      let that = this;
      function _callBack() {
        const target = that.childPublishListData.filter(
          item => item.key === key
        )[0];
        target.editable = false;
        target.isNew = false;
      }
      if (this.globalEditAble) {
        if (record.isNew) {
          // 新增
          const data = {
            unitPrice: record.price,
            amount: record.amount,
            publicMenuType: this.publishMealType,
            date: this.publishDate,
            addOrEditMenuType: record.isPackage ? 2 : 1
          };
          if (record.isPackage) {
            data.Code = record.packageCode;
          } else {
            data.menuId = record.menuId;
          }

          this.publishTableLoading = true;

          addPublishMenu(data).then(res => {
            this.publishTableLoading = false;
            if (res.data.state === 1) {
              this.$message.success("添加成功");
              _callBack();
            }
          }, res => { this.publishTableLoading = false; });
        } else {
          // 修改提交
          const data = {
            id: record.id,
            unitPrice: record.price,
            amount: record.amount,
            addOrEditMenuType: record.isPackage ? 2 : 1
          };
          this.publishTableLoading = true;
          // debugger
          editPublishMenu(data).then(res => {
            this.publishTableLoading = false;
            if (res.data.state === 1) {
              this.$message.success("修改成功");
              _callBack();
            }
          }, res => {
            this.publishTableLoading = false;
          });
        }
      } else {
        _callBack();
      }
    },
    // 保存或编辑
    editRow(record) {
      this.menuSelectDDefaaultVal = record.name;
      const target = this.childPublishListData.filter(
        item => item.key === record.key
      )[0];
      target.editable = !target.editable;
    },
    getRowByKey(key, newData) {
      const data = this.childPublishListData;
      return (newData || data).filter(item => item.key === key)[0];
    },
    // 取消
    cancel(key) {
      const target = this.childPublishListData.filter(
        item => item.key === key
      )[0];
      target.editable = false;
    },
    // 处理
    handleChange(value, key, column) {
      const newData = [...this.childPublishListData];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.childPublishListData = newData;
      }
    },
    // 菜品下拉选中
    handleMenuSelect(key, args) {
      const item = args[0];
      const currentIndex = this.childPublishListData.findIndex(value => {
        return value.key === key;
      })
      const currentEditObj = this.childPublishListData[currentIndex];

      currentEditObj.name = item.name;
      currentEditObj.img = item.imgUrl;
      currentEditObj.price = item.defaultUnitPrice;
      currentEditObj.desc = item.describe || item.remark ? item.remark : "-";
      currentEditObj.menuId = item.id;
      currentEditObj.packageCode = item.code;
      currentEditObj.isPackage = item.isPackage;
      currentEditObj.menuList = item.isPackage ? item.menus : [];
    },
    // 发布菜单提交
    publishMenuSubmit() {
      if (this.childPublishListData.length === 0) {
        this.$message.warning("请先添加菜品");
      } else {
        const errorData = this.childPublishListData.filter(
          item => item.isNew || item.editable
        );
        if (errorData.length) {
          this.$message.warning("请先完成菜品的添加与修改");
          return;
        }

        let data = {
          menus: [],
          packages: [],
          publicMenuType: this.publishMealType,
          date: this.publishDate
        };
        const tempMenuIds = []; // 接收menuId
        const tempPackageIds = []; // 接收packageId

        this.childPublishListData.forEach(item => {
          if (item.isPackage) {
            tempPackageIds.push(item.menuId);
            data.packages.push({
              Code: item.packageCode,
              PackagePrice: item.price,
              Amount: item.amount
            });
          } else {
            tempMenuIds.push(item.menuId);
            data.menus.push({
              menuId: item.menuId,
              unitPrice: item.price,
              amount: item.amount
            });
          }
        });

        if (arrIsRepeat(tempMenuIds) || arrIsRepeat(tempPackageIds)) {
          this.$message.warning("发布列表中包含相同菜品或套餐，请检查后再发布");
          return;
        }

        this.publishMenuSubmitLoading = true;

        const submitFn = message => {
          const that = this;
          that.$confirm({
            title: "您确定要发布当餐菜品吗？",
            content: message || (
              <div style="color: #1890ff;">您发布的菜品符合平衡膳食标准!</div>
            ),
            onOk() {
              onekeyPublishMenu(data).then(res => {
                if (res.data.state === 1) {
                  that.$message.success("提交成功");
                  that.$emit("publishMenuSubmit");
                } else {
                  that.$message.warning(res.data.message);
                }
              });
            }
          });
        };

        if (tempMenuIds.length === 0) {
          submitFn();
        } else {
          publishMenuTest({
            ids: JSON.stringify(tempMenuIds),
            type: this.publishMealType
          }).then(res => {
            const result = res.data.attribute;
            this.publishMenuSubmitLoading = false;
            let message = "";
            if (result.state === 1) {
              message = (<div style="color: #1890ff;margin:5px 0;">{result.reason ? result.reason : '您发布的菜品符合平衡膳食标准!'}</div>)
            } else if (result.state === 2) {
              message = (<div style="color: #fa8c16; margin:5px 0;">{result.reason}</div>)
            }
            submitFn(message);
          });
        }
      }
    }
  },
  computed: {
    publishMealTypeName: function () {
      return this.publishMealType === 1
        ? "早餐"
        : this.publishMealType === 2
          ? "午餐"
          : "晚餐";
    }
  },
  components: {
    menuSelect,
    selectAllMenu
  },
  mounted() {
    this._getMenuType()
  },
  watch: {
    globalEditAble: function (data) {
      if (data === false) {
        this.drawerTitle = "发布菜品";
        setTimeout(() => {
          document.querySelector(".ant-drawer-body").style.maxHeight =
            "calc(100% - 108px)";
        }, 100);
      } else if (data === true) {
        this.drawerTitle = "修改发布菜品";
        setTimeout(() => {
          document.querySelector(".ant-drawer-body").style.maxHeight =
            "calc(100% - 55px)";
        }, 100);
      }
    },
    publishListData: function (data) {
      this.childPublishListData = data;
    }
  }
};
</script>

<style lang="less">
.ant-drawer-body {
  max-height: calc(100% - 108px);
  overflow-y: scroll;
}
</style>


